export default {
    socialminer: {
        host: "VLSSM.velsol.com"
    },

    chat: {
        feedid: "100017",
        author: "Shop Customer",
        title: "New visitor on Web page",
        name: "CCX Chat",
        ccx_csq_id: 81,
        pollingInterval: 5000,
        widgetName: "FedExSalesChat"
    },

    popup: {
        elementid: "popup_chat_div",
        initdelay: 10000,
        myself: "Me"
    }
};